import { AboutUs } from "components/about-us/AboutUs";
import { GetStaticProps } from "next";

import getTranslations from "../lib/getTranslations";
import { getPublications } from "@/components/about-us/getPublications";
import {
  JobsQuery_jobs_JobEntityResponseCollection_data_JobEntity as JobEntity,
  PublicationsQuery_publications_PublicationEntityResponseCollection_data_PublicationEntity as PublicationEntry,
} from "@/strapi/schema";

export type AboutUsPageProps = {
  jobs: JobEntity[];
  publications: PublicationEntry[];
};

const AboutUsPage = ({ publications }: AboutUsPageProps) => {
  return <AboutUs jobs={[]} publications={publications} />;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const publicationsResponse = await getPublications({ locale: locale });
  const { publications } = publicationsResponse;

  return {
    props: {
      ...(await getTranslations(locale, ["about"])),
      jobs: [],
      publications,
    },
  };
};

export default AboutUsPage;
